import { CONVEYOR_MODE } from './conveyor.js';

// The simple editor: the operator writes a prompt and draws named marks; everything
// the old form asked (source, region direction, edges, type, tolerances, calibration,
// the two switches) is inferred or defaulted. The old blocks stay behind this flag
// until Brian has seen two rounds (design 2026-09-15-simple-editor, §8).
export const SIMPLE_EDITOR = true;

export const BEHAVIOURS = [
  ['conditional', 'Pass / fail'],
  ['conversational', 'Answer'],
  [CONVEYOR_MODE, 'Conveyor'],
];

// The second line used to read "R1 to R2 is 30 mm. Is L1 between 39 and 41 mm?" and the
// simple editor has nowhere to put that 30 mm: the calibration block sits behind the old
// form, so every marker measurement comes back in pixels and the question could not be
// answered as asked.
// TODO(untracked): put the millimetre example back when the prompt itself can set the
// scale (calibrationFromPrompt, F2 of docs/spatial-vision/2026-09-15-simple-editor-plan.md).
export const PROMPT_PLACEHOLDER =
  'Is there a crack on the surface?\nIs the crack inside A1?';
export const PROMPT_HINT =
  'Draw on the image to name what you mean: R1, L1, A1, D1.';

// A reference with marks is a markers condition, a reference without one an image
// condition, no reference a text condition. The operator never picks a source.
export function inferConditionMode({ behaviour, hasReference, hasMarkers }) {
  if (behaviour === CONVEYOR_MODE) return CONVEYOR_MODE;
  const suffix =
    behaviour === 'conversational' ? 'conversational' : 'conditional';
  if (hasReference && hasMarkers) return `markers-${suffix}`;
  if (hasReference) return `image-${suffix}`;
  return `text-${suffix}`;
}

// The simple editor has no region control and never will: the decision is that the
// words limit the search, not the drawing. So a condition saved there has no region of
// its own, and saving one takes the copy the old build left on it off as well. The old
// form draws a region by hand, and there it is the operator's own geometry.
export function conditionRoi(roiDraft) {
  return SIMPLE_EDITOR ? null : roiDraft || null;
}

export function behaviourOf(mode) {
  if (mode === CONVEYOR_MODE) return CONVEYOR_MODE;
  return String(mode || '').endsWith('conversational')
    ? 'conversational'
    : 'conditional';
}

export function behaviourWord(mode) {
  return BEHAVIOURS.find(([value]) => value === behaviourOf(mode))[1];
}
